import every from 'lodash/every';

import { TestCasesCollection } from '@qality/common-model';

export default {
  checkAllExpanded(testCases: TestCasesCollection): boolean {
    return every(testCases.testCases, { expanded: true });
  },
};
